import { useState } from "react"
import Loader from "../Loader";
import SystemModal from "../SystemModal";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-hot-toast';


const WalletTransactionsFilterForm=(props)=>{

    const [loading, setLoading] = useState(false)
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const navigate = useNavigate();

    const handleSearch = async (e) => {
        e.preventDefault();
        setLoading(false);
        if (!startDate || !endDate) {
            toast.error("Please select both start and end dates.");
            return;
        }

        const start = new Date(startDate);
        const end = new Date(endDate);

        if (start > end) {
            toast.error("Start date cannot be after end date.");
            return;
        }

        const oneMonthInMs = 31 * 24 * 60 * 60 * 1000; // Roughly one month
        const diff = end - start;

        if (diff > oneMonthInMs) {
            toast.error("Date range cannot exceed one month.");
            return;
        }

        navigate("/vendor-balances/statement/" + props.userID +
            "?username=" + encodeURIComponent(props.username) +
            "&user=" + encodeURIComponent(props.user) +
            "&balance=" + encodeURIComponent(props.balance) +
            "&startDate=" + startDate +
            "&endDate=" + endDate);
    };

    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleSearch}>Filter<i class="fas fa-check mg-l-15"></i></button>
                    </>
        }
    }

    return(
        <SystemModal
            title="Filter Wallet Transactions"
            id="model-wallet-filter"
            size="md"
            footer={RenderFooter}
        >

        
            <div className="mb-4 form-group border-1">
                <label htmlFor="">Start Date</label>
                <input  onChange={(e) => setStartDate(e.target.value)}  style={{border: "1px solid grey"}} value={startDate} type="date" className="form-control"/>
            </div>
            <div className="mb-4 form-group border-1">
                <label htmlFor="">End Date</label>
                <input onChange={(e) => setEndDate(e.target.value)}  style={{border: "1px solid grey"}} value={endDate} type="date" className="form-control"/>
            </div>
        
       
        </SystemModal>
    )
}

export default WalletTransactionsFilterForm
